<main>
  <router-outlet></router-outlet>
</main>

<footer>
  This site is open source on <a href="https://gitlab.com/chris13524/chris.smith.xyz" routerLinkActive="_link-active">GitLab</a>.
</footer>
